import { getData as getAddressData } from '../Address';
import { getData as getAggregateRatingData } from '../StarRating';
export function getHours(owner) {
  const hours = owner?.hours;
  let value = '';
  if (hours) {
    value = hours.reduce((acc, _ref) => {
      let {
        label,
        open,
        close
      } = _ref;
      return acc.concat(`${label} ${open}-${close} `);
    }, ['Hours: ']).join('');
  }
  return value;
}
const getImage = _ref2 => {
  let {
    images
  } = _ref2;
  // Prefer first dealership image
  if (images?.sources?.[0]?.src) {
    return images.sources[0].src;
  }
  // Default: Ghost dealership image
  return 'https://www.autotrader.com/content/dam/autotrader/shared/img/dealership-noimage-placeholder.png';
};
export default function getData(owner, description) {
  if (owner === void 0) {
    owner = {};
  }
  const {
    location,
    rating,
    name,
    logo
  } = owner;
  const address = location && getAddressData(location);
  const phoneValue = owner?.phone?.value || '';
  let schema = {
    '@context': 'https://schema.org',
    '@type': 'AutoDealer',
    openingHours: getHours(owner),
    ...address,
    telephone: phoneValue,
    image: getImage(owner),
    logo,
    name,
    description
  };
  if (rating && (rating.value || rating.count)) {
    schema = {
      ...schema,
      ...getAggregateRatingData(rating)
    };
  }
  return schema;
}